<template>
  <div class="topic-item">
    <slot>
      <div class="slot">
        <div class="total">{{preCount}}</div>
        <div class="desc">人在参与</div>
      </div>
    </slot>
    <img v-lazy="`${imageURL}?x-oss-process=image/resize,m_fill,w_1280,h_720`" alt="">
    <div class="content">
      <span class="title">{{title}}</span>
      <span class="desc">{{subTitle}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imageURL: {
      type: String,
      default: 'http://exerlalnd.oss-cn-shanghai.aliyuncs.com/exerland-m/forum.png'
    },
    title: {
      type: String,
      default: '这里是话题的主标题主标题主标题主标题'
    },
    subTitle: {
      type: String,
      default: '这里是话题的主标题主标题主标题主标题'
    },
    preCount: {
      type: Number,
      default: 12313
    }
  }
}
</script>
<style lang="scss" scoped>
.topic-item {
  width: 100%;
  // height: 284px;
  background:rgba(255,255,255,1);
  box-sizing: border-box;
  position: relative;
  .slot {
    position: absolute;
    top: 0;
    right: 13px;
    width:66px;
    box-sizing: border-box;
    background:rgba(0,0,0,0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // padding: 9px 9px 5px;
    .total {
      font-size:17px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(24,204,159,1);
      line-height:24px;
      text-align: center;
    }
    .desc {
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(255,255,255,1);
      line-height:17px;
    }
  }
  img {
    width: 100%;
    height: 208px;
  }
  .content {
    padding: 14px 15px;
    display: flex;
    flex-direction: column;
    .title {
      font-size:17px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(0,0,0,1);
      line-height:24px;
      display: block;
      margin-bottom: 6px;
    }
    .desc {
      font-size:13px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(136,136,136,1);
      line-height:18px;
    }
  }
}
</style>
